<template>
  <router-view />
  <BaseNotifications></BaseNotifications>
</template>

<script setup lang="tsx">
import LogoConnect from "@/components/LogoConnect.vue";
import { routeNames } from "@/routes";
import { useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { useRoute } from "vue-router";

const route = useRoute();
const appSettingsStore = useAppSettingsStore();
const { setNavigationItems, setApplicationTitleComponent, setSuiteLogoComponent } = useAppNav();

const SmallComponent = () => <div class="">{appSettingsStore.pageTitleBase}</div>;
setApplicationTitleComponent(SmallComponent);

const connectUrl = import.meta.env.VITE_CONNECT_URL;

if (connectUrl) {
  setSuiteLogoComponent(() => (
    <a
      class="ml-6 flex items-center rounded-l-full bg-neutral-300 pl-3  pr-3 hover:bg-neutral-400"
      href={connectUrl}
      target="_blank"
      aria-label="EHA Connect"
    >
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </a>
  ));
} else {
  setSuiteLogoComponent(() => (
    <div class="ml-6 flex items-center rounded-l-full bg-neutral-300 pl-3 pr-3">
      <LogoConnect class="h-10 w-10" background-color="white" foreground-color="#999" />
    </div>
  ));
}

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [{ label: "Home", name: routeNames.home }],
  },
  {
    label: "items",
    className: "",
    showLabel: false,
    items: [
      { label: "Grants", name: routeNames.grant.grants },
      { label: "Contracts", name: routeNames.contract.contracts },
      // { label: "Systems", name: routeNames.systems },
      { label: "Projects", name: routeNames.project.projects },
      { label: "Accounts", name: routeNames.account.accounts },
    ],
  },
  {
    label: "analytics",
    className: "",
    showLabel: false,
    items: [
      { label: "Project Data Download", name: routeNames.analytics.projectDataDownload },
      { label: "Billing Detail Download", name: routeNames.analytics.billingDetailDownload },
    ],
  },
]);
</script>
